import Banner from "../components/Banner";
import ExploreSlider from "../components/ExploreSlider";
import RegisterCallout from "../components/RegisterCallout";
import ExploreNearData27 from "../data/ExploreNearData27";
import ExploreFarData27 from "../data/ExploreFarData27";

export default function PageExplore() {
  return (
    <>
      <Banner
        leftImage="img/bg-banner-round-gradient.webp"
        className="bg-white-after"
      >
        <div className="col-12 mb-3">
          <div className="display-1 color-white">Explore Carlsbad</div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-0">
            Discover what's just steps away or a short ride from Omni La Costa
            Resort during FinComp 2027.
          </p>
        </div>
      </Banner>

      <section className="sliders">
        <ExploreSlider
          title="On or Near the Resort"
          subTitle="Discover something new at these walkable destinations"
          data={ExploreNearData27}
        />

        <br />
        <br />

        <ExploreSlider
          title="Worth the Drive"
          subTitle="Want to extend your trip or sneak in an adventure? These are just a short Uber away."
          data={ExploreFarData27}
        />
      </section>

      <RegisterCallout />
    </>
  );
}
